// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1fdIT","title":"FrontImage_title__d9YE1"};